var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoInCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 72,
    height: 72,
    rx: 36,
    fill: "#F4F9FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.167 30.6665C35.167 29.9305 35.7643 29.3332 36.5003 29.3332C37.2363 29.3332 37.8337 29.9305 37.8337 30.6665C37.8337 31.4025 37.2363 31.9998 36.5003 31.9998C35.7643 31.9998 35.167 31.4025 35.167 30.6665ZM35.167 34.6665C35.167 33.9305 35.7643 33.3332 36.5003 33.3332C37.2363 33.3332 37.8337 33.9305 37.8337 34.6665V41.3332C37.8337 42.0692 37.2363 42.6665 36.5003 42.6665C35.7643 42.6665 35.167 42.0692 35.167 41.3332V34.6665ZM36.5003 46.6665C30.619 46.6665 25.8337 41.8812 25.8337 35.9998C25.8337 30.1185 30.619 25.3332 36.5003 25.3332C42.3817 25.3332 47.167 30.1185 47.167 35.9998C47.167 41.8812 42.3817 46.6665 36.5003 46.6665ZM36.5003 22.6665C29.1363 22.6665 23.167 28.6358 23.167 35.9998C23.167 43.3638 29.1363 49.3332 36.5003 49.3332C43.863 49.3332 49.8337 43.3638 49.8337 35.9998C49.8337 28.6358 43.863 22.6665 36.5003 22.6665Z",
    fill: "#00A0F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoInCircle);
export default __webpack_public_path__ + "static/media/info-in-circle.04a9198e20348e7bac22783cfefc905a.svg";
export { ForwardRef as ReactComponent };